export function formatPaymentUserName(paymentUserName: any): string {
  // Check if the input is empty, null, or undefined
  if (!paymentUserName || !(typeof paymentUserName === 'string') || paymentUserName.trim() === '') {
    return '/'
  }

  // Split the name into parts
  const nameParts = paymentUserName.trim().split(' ')

  let firstName = ''
  let lastName = ''

  // Check the number of parts in the name
  if (nameParts.length === 1) {
    // Single name, treat it as last name
    lastName = nameParts[0]
  } else if (nameParts.length === 2) {
    // First and last name without middle initial
    ;[firstName, lastName] = nameParts
  } else {
    // More than two names
    if (nameParts[1].length === 1) {
      firstName = nameParts[0]
      lastName = nameParts[nameParts.length - 1]
    } else {
      firstName = `${nameParts[0]} ${nameParts[1]}`
      lastName = nameParts[nameParts.length - 1]
    }
  }

  // Format the name in uppercase LASTNAME/FIRSTNAME format
  const formattedFirstName = firstName.toUpperCase()
  const formattedLastName = lastName.toUpperCase()
  return `${formattedLastName}/${formattedFirstName}`
}

export function getTouchEvent() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 ? 'onTouchEnd' : 'onClick'
}

/**
 * Returns true if at least one item from the next round order exists in the
 * provided list of available menu items. Returns false when there is no next
 * round order or none of its items are available.
 */
export function isNextRoundAvailable(
  nextRoundOrder: { order: { item_id: number }[] } | null | undefined,
  availableItems: { item_id: number }[]
): boolean {
  if (!nextRoundOrder?.order?.length) return false
  return nextRoundOrder.order.some((orderItem) => availableItems.some((item) => item.item_id === orderItem.item_id))
}

/**
 * Parses a string to float and returns it as a string.
 * If the parsed value has a fractional part, it is rounded to the nearest 2 decimal places.
 * @param value - The string value to parse
 * @param decimalPlaces - Number of decimal places to round to (default: 2)
 * @returns The formatted value as a string, or empty string if input is invalid
 */
export function parseFloatAndRound(value: string | null | undefined, decimalPlaces: number = 2): string {
  if (!value || typeof value !== 'string' || value.trim() === '') {
    return ''
  }

  const parsed = parseFloat(value)

  if (isNaN(parsed)) {
    return ''
  }

  // If the parsed value already has a fractional part, do not apply rounding.
  if (parsed % 1 !== 0) {
    return parsed.toFixed(2)
  }

  return parsed.toFixed(decimalPlaces)
}
